import styled from '@emotion/styled';
import {forwardRef, InputHTMLAttributes, useId} from 'react';


const Box = styled.div`
    position: relative;
    height: 20px;
`

const Input = styled.input`
    position: absolute;
    appearance: none;
    height: 100%;
    width: 100%;
    aspect-ratio: 1;
    left: -2px;

    &:checked + label {
        &::before {
            content: '';
            z-index: 0;
            border: 2px solid #0062CC;
        }
    }

    &:checked + label {
        &::after {
            content: '';
            z-index: 0;

            border: 2px solid #0062CC;
            border-top: none;
            border-left: none;
            height: 7px;
            width: 5px;
            transform: rotate(45deg);
        }
    }
`

const Label = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    margin-left: 8px;

    &::before {
        content: '';
        box-sizing: border-box;
        display: inline-block;
        aspect-ratio: 1;
        line-height: 15px;
        margin: 0 5px 0 0;
        border-radius: 50%;
        border: 2px solid #D9D9D9;
        width: 20px;
        height: 20px;
    }

    &::after {
        content: '';
        position: absolute;
        left: 14px;
        top: 4px;
        border: 2px solid #D9D9D9;
        border-top: none;
        border-left: none;
        height: 7px;
        width: 5px;
        transform: rotate(45deg);
    }
`
const Span = styled.span`
    color: #f14252;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    padding-right: 4px;
`;

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
    isRequired?: boolean; // 추가
}

const CheckBox = forwardRef<HTMLInputElement, Props>(({label, isRequired, ...props}, ref) => {
    const id = useId();
    return (
        <Box>
            <Input id={id} type={'checkbox'} {...props} ref={ref}/>
            <Label htmlFor={id}>
                {isRequired && <Span>(필수)</Span>}
                {label}
            </Label>
        </Box>
    );
})

export default CheckBox;
